import * as setup from '@/setup';
import Button from '@/objects/button';
import Header from '@/objects/header';
import * as auth from '@/utils/auth';
import axios from 'axios';
import * as config from '@/config-APP_TARGET';
import runtime from '@/runtime';
import { getModel } from '@/utils/model';
import * as audio from '@/utils/audio';
import { HEADER_HEIGHT } from '@/constants';

/**
 * Chiave localStorage per tracciare le sfide concluse gia viste
 */
var SEEN_COMPLETED_CHALLENGES_KEY = 'seen_completed_challenges';

export default class GameSelection extends Phaser.Scene {
	constructor() {
		super({ key: 'GameSelection' });
		this.games = [];
		this.loadingText = null;
		this.errorText = null;
		this.pendingChallengesPopupShown = false;
		this.completedChallengesPopupShown = false;
	}

	create() {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;

		// Background
		this.add
			.image(centerX, height / 2, 'background')
			.setOrigin(0.5, 0.5);

		// Header
		this.createHeader(centerX);

		// Mostra loading
		this.loadingText = this.add.text(
			centerX,
			height / 2,
			'Caricamento giochi...',
			{
				fontSize: 32,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5);

		// Carica la lista dei giochi
		this.loadGames();

		// Controlla sfide pendenti dopo un breve delay
		// per dare tempo alla chiamata API di completarsi
		this.checkPendingChallengesWithDelay();
	}

	/**
	 * Controlla le sfide pendenti con un delay per dare tempo alla chiamata API
	 */
	checkPendingChallengesWithDelay() {
		var scene = this;

		// Aspetta 500ms e poi controlla il registry
		this.time.delayedCall(500, function() {
			scene.checkAndShowChallenges();
		});

		// Ascolta anche i cambiamenti nel registry
		this.registry.events.on('changedata-pending_challenges_count', function(parent, value) {
			scene.checkAndShowChallenges();
		});
		this.registry.events.on('changedata-completed_challenges_count', function(parent, value) {
			scene.checkAndShowChallenges();
		});
	}

	/**
	 * Verifica se ci sono sfide da mostrare (pendenti o concluse)
	 */
	checkAndShowChallenges() {
		var scene = this;

		// Prima controlla le sfide da giocare
		if (!this.pendingChallengesPopupShown) {
			var pendingCount = this.registry.get('pending_challenges_count');
			if (pendingCount && pendingCount > 0) {
				this.pendingChallengesPopupShown = true;
				this.showPendingChallengesPopup(pendingCount);
				return; // Mostra un popup alla volta
			}
		}

		// Poi controlla le sfide concluse
		if (!this.completedChallengesPopupShown) {
			var completedCount = this.registry.get('completed_challenges_count');
			if (completedCount && completedCount > 0) {
				this.completedChallengesPopupShown = true;
				this.showCompletedChallengesPopup(completedCount);
			}
		}
	}

	/**
	 * Verifica se ci sono sfide pendenti e mostra il popup
	 * @deprecated Usa checkAndShowChallenges
	 */
	checkAndShowPendingChallenges() {
		this.checkAndShowChallenges();
	}

	/**
	 * Marca le sfide concluse come viste nel localStorage
	 * @param {Array} challenges Array di sfide da marcare come viste
	 */
	markChallengesAsSeen(challenges) {
		if (!challenges || challenges.length === 0) {
			return;
		}

		// Ottieni gli ID gia visti
		var stored = localStorage.getItem(SEEN_COMPLETED_CHALLENGES_KEY);
		var seenIds = [];
		if (stored) {
			try {
				seenIds = JSON.parse(stored);
			} catch (e) {
				seenIds = [];
			}
		}

		// Aggiungi i nuovi ID
		challenges.forEach(function(challenge) {
			if (seenIds.indexOf(challenge.id) === -1) {
				seenIds.push(challenge.id);
			}
		});

		// Salva nel localStorage
		localStorage.setItem(SEEN_COMPLETED_CHALLENGES_KEY, JSON.stringify(seenIds));

		// Reset il conteggio nel registry
		this.registry.set('completed_challenges_count', 0);
		this.registry.set('completed_challenges_data', []);
	}

	/**
	 * Mostra il popup con le sfide concluse
	 * @param {number} count Numero di sfide concluse
	 */
	showCompletedChallengesPopup(count) {
		var scene = this;
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Ottieni i dati delle sfide concluse
		var completedChallenges = this.registry.get('completed_challenges_data') || [];

		// Container per tutti gli elementi del popup
		var popupElements = [];

		// Sfondo semi-trasparente che copre tutto
		var overlay = this.add.rectangle(
			centerX,
			centerY,
			width,
			height,
			0x000000,
			0.7
		).setOrigin(0.5).setDepth(100).setInteractive();
		popupElements.push(overlay);

		// Box bianco centrale
		var boxWidth = width - 60;
		var boxHeight = 280;
		var box = this.add.rectangle(
			centerX,
			centerY,
			boxWidth,
			boxHeight,
			0xFFFFFF,
			1
		).setOrigin(0.5).setDepth(101);
		box.setStrokeStyle(4, 0x4CAF50);
		popupElements.push(box);

		// Icona trofeo
		var iconText = this.add.text(
			centerX,
			centerY - 90,
			'🏆',
			{
				fontSize: 48
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(iconText);

		// Titolo
		var titleText = count === 1 ? 'Sfida conclusa!' : count + ' sfide concluse!';
		var title = this.add.text(
			centerX,
			centerY - 30,
			titleText,
			{
				fontSize: 36,
				fontFamily: 'Luckiest Guy',
				fill: '#4CAF50',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(title);

		// Sottotitolo
		var subtitle = this.add.text(
			centerX,
			centerY + 15,
			'Scopri chi ha vinto!',
			{
				fontSize: 22,
				fontFamily: 'Arial',
				fill: '#333333',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(subtitle);

		// Bottone "Vedi risultati"
		var viewButton = this.add.rectangle(
			centerX - 80,
			centerY + 80,
			140,
			50,
			0x4CAF50,
			1
		).setOrigin(0.5).setDepth(102).setInteractive({ useHandCursor: true });
		popupElements.push(viewButton);

		var viewButtonText = this.add.text(
			centerX - 80,
			centerY + 80,
			'Vedi risultati',
			{
				fontSize: 20,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(103);
		popupElements.push(viewButtonText);

		// Bottone "Dopo"
		var laterButton = this.add.rectangle(
			centerX + 80,
			centerY + 80,
			140,
			50,
			0x888888,
			1
		).setOrigin(0.5).setDepth(102).setInteractive({ useHandCursor: true });
		popupElements.push(laterButton);

		var laterButtonText = this.add.text(
			centerX + 80,
			centerY + 80,
			'Dopo',
			{
				fontSize: 22,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(103);
		popupElements.push(laterButtonText);

		// Funzione per chiudere il popup
		var closePopup = function() {
			popupElements.forEach(function(el) {
				el.destroy();
			});
		};

		// Click su "Vedi risultati" -> marca come viste e vai alla scena Challenge
		viewButton.on('pointerup', function() {
			scene.markChallengesAsSeen(completedChallenges);
			closePopup();
			scene.scene.start('Challenge');
		});

		// Click su "Dopo" -> marca come viste e chiudi popup
		laterButton.on('pointerup', function() {
			scene.markChallengesAsSeen(completedChallenges);
			closePopup();
		});

		// Effetto hover sui bottoni
		viewButton.on('pointerover', function() {
			viewButton.setFillStyle(0x45A049);
		});
		viewButton.on('pointerout', function() {
			viewButton.setFillStyle(0x4CAF50);
		});

		laterButton.on('pointerover', function() {
			laterButton.setFillStyle(0x666666);
		});
		laterButton.on('pointerout', function() {
			laterButton.setFillStyle(0x888888);
		});
	}

	/**
	 * Mostra il popup con le sfide pendenti
	 * @param {number} count Numero di sfide pendenti
	 */
	showPendingChallengesPopup(count) {
		var scene = this;
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Container per tutti gli elementi del popup
		var popupElements = [];

		// Sfondo semi-trasparente che copre tutto
		var overlay = this.add.rectangle(
			centerX,
			centerY,
			width,
			height,
			0x000000,
			0.7
		).setOrigin(0.5).setDepth(100).setInteractive();
		popupElements.push(overlay);

		// Box bianco centrale
		var boxWidth = width - 60;
		var boxHeight = 280;
		var box = this.add.rectangle(
			centerX,
			centerY,
			boxWidth,
			boxHeight,
			0xFFFFFF,
			1
		).setOrigin(0.5).setDepth(101);
		box.setStrokeStyle(4, 0xFF6B00);
		popupElements.push(box);

		// Icona sfida (emoji o testo)
		var iconText = this.add.text(
			centerX,
			centerY - 90,
			'⚔️',
			{
				fontSize: 48
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(iconText);

		// Titolo
		var titleText = count === 1 ? 'Hai una sfida!' : 'Hai ' + count + ' sfide!';
		var title = this.add.text(
			centerX,
			centerY - 30,
			titleText,
			{
				fontSize: 36,
				fontFamily: 'Luckiest Guy',
				fill: '#FF6B00',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(title);

		// Sottotitolo
		var subtitle = this.add.text(
			centerX,
			centerY + 15,
			'I tuoi amici ti aspettano!',
			{
				fontSize: 22,
				fontFamily: 'Arial',
				fill: '#333333',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(102);
		popupElements.push(subtitle);

		// Bottone "Vedi sfide"
		var viewButton = this.add.rectangle(
			centerX - 80,
			centerY + 80,
			140,
			50,
			0xFF6B00,
			1
		).setOrigin(0.5).setDepth(102).setInteractive({ useHandCursor: true });
		popupElements.push(viewButton);

		var viewButtonText = this.add.text(
			centerX - 80,
			centerY + 80,
			'Vedi sfide',
			{
				fontSize: 22,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(103);
		popupElements.push(viewButtonText);

		// Bottone "Dopo"
		var laterButton = this.add.rectangle(
			centerX + 80,
			centerY + 80,
			140,
			50,
			0x888888,
			1
		).setOrigin(0.5).setDepth(102).setInteractive({ useHandCursor: true });
		popupElements.push(laterButton);

		var laterButtonText = this.add.text(
			centerX + 80,
			centerY + 80,
			'Dopo',
			{
				fontSize: 22,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(103);
		popupElements.push(laterButtonText);

		// Funzione per chiudere il popup
		var closePopup = function() {
			popupElements.forEach(function(el) {
				el.destroy();
			});
		};

		// Click su "Vedi sfide" -> vai alla scena Challenge
		viewButton.on('pointerup', function() {
			closePopup();
			scene.scene.start('Challenge');
		});

		// Click su "Dopo" -> chiudi popup
		laterButton.on('pointerup', function() {
			closePopup();
		});

		// Effetto hover sui bottoni
		viewButton.on('pointerover', function() {
			viewButton.setFillStyle(0xE55D00);
		});
		viewButton.on('pointerout', function() {
			viewButton.setFillStyle(0xFF6B00);
		});

		laterButton.on('pointerover', function() {
			laterButton.setFillStyle(0x666666);
		});
		laterButton.on('pointerout', function() {
			laterButton.setFillStyle(0x888888);
		});
	}

	createHeader(centerX) {
		const headerY = HEADER_HEIGHT / 2;

		// Usa il componente Header
		new Header(this, 'GIOCHI');

		// Pulsante back (icona) - separato dal componente Header
		const backArrow = this.add.image(40, headerY, 'back-icon');
		backArrow.setOrigin(0, 0.5);
		backArrow.setInteractive({ useHandCursor: true });

		backArrow.on('pointerup', () => {
			audio.playSound(this, 'button-click');
			this.scene.start('MainMenu');
		});
	}

	loadGames() {
		var scene = this;
		var token = auth.getToken();

		axios.get(config.apiUrl + '/api/games?expand=modes', {
			headers: {
				'Authorization': 'Bearer ' + token
			}
		})
		.then(function(response) {
			scene.games = response.data;
			scene.loadingText.destroy();
			scene.displayGames();
		})
		.catch(function(error) {
			console.error('Errore caricamento giochi:', error);
			scene.loadingText.destroy();
			scene.showError('Errore nel caricamento dei giochi');
		});
	}

	displayGames() {
		var scene = this;
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;

		// Area scrollabile per i giochi
		var startY = 220;
		var buttonSpacing = 140;
		var currentGameId = auth.getGameId();

		// Container per i giochi
		this.gamesContainer = this.add.container(0, 0);

		this.games.forEach(function(game, index) {
			var y = startY + (index * buttonSpacing);

			// Card del gioco
			var cardBg = scene.add.rectangle(centerX, y, width - 80, 120, 0x1a5a7a, 1);
			cardBg.setStrokeStyle(3, currentGameId === game.id ? 0xffd700 : 0x2a7a9a);

			// Nome del gioco
			var nameText = scene.add.text(
				centerX,
				y - 25,
				game.name,
				{
					fontSize: 36,
					fontFamily: 'Luckiest Guy',
					fill: currentGameId === game.id ? '#FFD700' : '#FFFFFF',
					align: 'center'
				}
			).setOrigin(0.5);

			// Descrizione del gioco
			var descText = scene.add.text(
				centerX,
				y + 20,
				game.description || 'Nessuna descrizione',
				{
					fontSize: 20,
					fontFamily: 'Arial',
					fill: '#CCCCCC',
					align: 'center',
					wordWrap: { width: width - 120 }
				}
			).setOrigin(0.5);

			// Indicatore se selezionato
			if (currentGameId === game.id) {
				var selectedIcon = scene.add.text(
					width - 60,
					y,
					'✓',
					{
						fontSize: 40,
						fontFamily: 'Arial',
						fill: '#FFD700',
						align: 'center'
					}
				).setOrigin(0.5);
				scene.gamesContainer.add(selectedIcon);
			}

			// Rendi la card interattiva
			cardBg.setInteractive({ useHandCursor: true });

			cardBg.on('pointerover', function() {
				cardBg.setFillStyle(0x2a7a9a);
			});

			cardBg.on('pointerout', function() {
				cardBg.setFillStyle(0x1a5a7a);
			});

			cardBg.on('pointerdown', function() {
				scene.selectGame(game);
			});

			scene.gamesContainer.add([cardBg, nameText, descText]);
		});

		// Se non ci sono giochi, mostra messaggio
		if (this.games.length === 0) {
			this.add.text(
				centerX,
				height / 2,
				'Nessun gioco disponibile',
				{
					fontSize: 32,
					fontFamily: 'Arial',
					fill: '#FF6666',
					align: 'center'
				}
			).setOrigin(0.5);
		}
	}

	selectGame(game) {
		var scene = this;

		// Salva game_id nel localStorage
		auth.saveGameId(game.id);

		// Verifica che ci sia almeno un game_mode disponibile
		if (!game.modes || game.modes.length === 0) {
			console.error('Nessun game_mode disponibile per il gioco:', game.name);
			scene.showError('Nessun game mode disponibile per questo gioco');
			return;
		}

		// Salva il primo game_mode_id
		var gameModeId = game.modes[0].id;
		auth.saveGameModeId(gameModeId);
		console.log('Gioco selezionato:', game.name, '(ID:', game.id, ', Mode ID:', gameModeId, ')');

		// Mostra feedback visivo
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;

		// Overlay di conferma
		var overlay = this.add.rectangle(centerX, height / 2, width, height, 0x000000, 0.7);

		var confirmText = this.add.text(
			centerX,
			height / 2 - 20,
			'Avvio gioco:\n' + game.name,
			{
				fontSize: 36,
				fontFamily: 'Luckiest Guy',
				fill: '#FFD700',
				align: 'center'
			}
		).setOrigin(0.5);

		var loadingText = this.add.text(
			centerX,
			height / 2 + 60,
			'Caricamento in corso...',
			{
				fontSize: 24,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5);

		// Ferma e distruggi la scena Game se esiste (per resettare animazioni e stato)
		var gameScene = scene.scene.get('Game');
		if (gameScene) {
			console.log('GameSelection - Fermando scena Game per cambio gioco');
			gameScene.registry.destroy();
			scene.scene.stop('Game');
		}

		// Ferma anche GameOver se esiste
		var gameOverScene = scene.scene.get('GameOver');
		if (gameOverScene) {
			gameOverScene.registry.destroy();
			scene.scene.stop('GameOver');
		}

		// Reset del flag gameInProgress
		runtime.gameInProgress = false;

		// Carica direttamente il gioco chiamando l'API
		axios.get(config.apiUrl + '/api/rounds/start?game_mode_id=' + gameModeId)
			.then(function (response) {
				// Salva i dati del gioco in runtime
				runtime.user = response.data.user;
				runtime.game = response.data.game;
				runtime.mode = getModel(runtime.game.modes, 'id', gameModeId);
				runtime.dict = response.data.dict;
				runtime.skills = response.data.skills;
				runtime.superpowers = response.data.superpowers;
				runtime.gamifications = response.data.gamifications;
				runtime.statuses = response.data.statuses;
				runtime.constants = response.data.constants;
				runtime.round = response.data.round;
				runtime.ranking = response.data.ranking;

				// Avvia direttamente la scena Game
				scene.scene.start('Game');
			})
			.catch(function (error) {
				console.error('Errore caricamento gioco:', error);
				
				// Rimuovi overlay e testi
				overlay.destroy();
				confirmText.destroy();
				loadingText.destroy();

				// Estrai il messaggio di errore dalla risposta
				var errorMessage = 'Errore di connessione! Riprova più tardi';
				if (error.response && error.response.data) {
					if (error.response.data.message) {
						errorMessage = error.response.data.message;
					} else if (error.response.data.success === false) {
						errorMessage = error.response.data.message || errorMessage;
					}
				}

				// Mostra errore
				scene.showError(errorMessage);
			});
	}

	showError(message) {
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;

		this.errorText = this.add.text(
			centerX,
			height / 2,
			message,
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FF6666',
				align: 'center'
			}
		).setOrigin(0.5);

		// Bottone riprova
		var retryButton = new Button(
			this,
			centerX,
			height / 2 + 80,
			'green-button',
			1.5,
			'Riprova',
			false
		);

		var scene = this;
		retryButton.on('pointerup', function() {
			scene.errorText.destroy();
			retryButton.destroy();
			scene.loadingText = scene.add.text(
				centerX,
				height / 2,
				'Caricamento giochi...',
				{
					fontSize: 32,
					fontFamily: 'Arial',
					fill: '#FFFFFF',
					align: 'center'
				}
			).setOrigin(0.5);
			scene.loadGames();
		});
	}
}
